import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { PricingCalculationSummary } from './models';

@Component({
    selector: 'qpx-publish-pricing-calculation',
    templateUrl: './pricing-calculation.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'block rounded-md border border-border p-4',
    },
})
export class PublishPricingCalculation {
    public readonly calculation = input.required<PricingCalculationSummary>();
}
